import { useNavigate } from 'react-router-dom'
import { Row, Col } from 'react-bootstrap'
import { DcsPermissions, GridCellEnum, ICustomColumn, IPageProps, IRootState } from 'types'
import { AddButton, PageHeader } from 'components'
import { V1ApiIntegrationsClient } from 'core/http-common'
import toast from 'core/toast'
import { useSelector } from 'react-redux'
import SAGrid, { GridGetDataProps, GetDataResponse } from 'components/Grid/SAGrid'
import { IFrazerPayMerchantDto } from 'generated/v1/v1IntegrationsApi'
import { getDeleteType, permissionRedirect } from 'core/helpers'
import { hasPermission } from 'state/reduxHelpers'

export interface IDropDownStringValue {
    id: string,
    text: string
}

const MerchantsPage = ({ title }: IPageProps) => {

    const navigate = useNavigate()
    const dealerColumns: ICustomColumn[] = [
        { field: 'dealerId', title: 'Dealer ID' },
        { field: 'dealerName', title: 'Dealer Name' },
        { field: 'paymentProcessorCcMerchantId', title: 'Merchant ID' },
        { field: 'action', title: 'Delete', sortable: false, headerClassName: 'text-center', width: '80px', cellType: GridCellEnum.DeleteAction }
    ]

    const fetch = async (props: GridGetDataProps): Promise<GetDataResponse> => {
        try {
            const result = await V1ApiIntegrationsClient.getFrazerPayMerchants(
                props.search,
                props.sortBy,
                props.sortAscending,
                props.paging && props.paging.currentPage ? props.paging.currentPage : 1,
                props.paging ? props.paging.take : 10,
            )

            return {
                data: result.data,
                total: result.totalItems ? result.totalItems : 0
            }
        }
        catch (e) {
            toast.responseErrors(e)
            return {
                data: [],
                total: 0
            }
        }
    }

    const deleteItem = async (item: IFrazerPayMerchantDto) => {

        await V1ApiIntegrationsClient.deleteFrazerPayMerchant(item.merchantId)
        toast.success('Frazer Pay Merchant was successfully deleted.')
    }

    const deleteMessage = (item: IFrazerPayMerchantDto) => {
        if (item) {
            return <div>Are you sure you want to delete the Merchant account for dealer <b>{item.dealerName}</b>?</div>
        }
    }

    return (
        <div id='MerchantsPage'>
            <PageHeader title={title}>
                <AddButton className='btn-lg btn-primary btnWidth mb-2 mb-md-0' onClick={() => permissionRedirect(DcsPermissions.AddMerchant, '/merchants/add', navigate)}>
                    Add Merchant
                </AddButton>
            </PageHeader>

            <Row>
                <Col>
                    <SAGrid
                        features={{
                            pageable: true,
                            reorderColumns: true,
                            sortable: true,
                            simpleSearch: true
                        }}
                        columns={dealerColumns}
                        defaultSort={[{ field: 'dealerId', dir: 'asc' }]}
                        getData={fetch}
                        deleteAction={{
                            handler: deleteItem,
                            canDelete: true,
                            deleteTitle: 'Delete Merchant Confirmation',
                            getDeleteMessage: deleteMessage,
                            // eslint-disable-next-line @typescript-eslint/no-explicit-any
                            getItemDeleteType: (item: any) => getDeleteType(hasPermission(DcsPermissions.DeleteMerchant), item.dealerId, false)

                        }}
                    />
                </Col>
            </Row>
        </div>
    )
}
export default MerchantsPage

